import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { EmailValidatorDirective } from './email-validator.directive';

@NgModule({
    imports: [
        FormsModule
    ],
    declarations: [EmailValidatorDirective],
    exports: [EmailValidatorDirective]
})
export class EmailValidatorModule {}
